import { Collapse } from '.';
import { Component } from '../../helpers/compiler';

@Component({ className: 'js-collapse' })
export class CollapseComponent {
	constructor(public element: HTMLElement) {
		const closeSiblings = (element.getAttribute('data-collapse-close-siblings') === 'true');

		new Collapse(element, { closeSiblings: closeSiblings });
	}
}
